// packages/alpinejs/src/scheduler.js
var $a404bd24cbc35777$var$flushPending = false;
var $a404bd24cbc35777$var$flushing = false;
var $a404bd24cbc35777$var$queue = [];
var $a404bd24cbc35777$var$lastFlushedIndex = -1;
function $a404bd24cbc35777$var$scheduler(callback) {
    $a404bd24cbc35777$var$queueJob(callback);
}
function $a404bd24cbc35777$var$queueJob(job) {
    if (!$a404bd24cbc35777$var$queue.includes(job)) $a404bd24cbc35777$var$queue.push(job);
    $a404bd24cbc35777$var$queueFlush();
}
function $a404bd24cbc35777$var$dequeueJob(job) {
    let index = $a404bd24cbc35777$var$queue.indexOf(job);
    if (index !== -1 && index > $a404bd24cbc35777$var$lastFlushedIndex) $a404bd24cbc35777$var$queue.splice(index, 1);
}
function $a404bd24cbc35777$var$queueFlush() {
    if (!$a404bd24cbc35777$var$flushing && !$a404bd24cbc35777$var$flushPending) {
        $a404bd24cbc35777$var$flushPending = true;
        queueMicrotask($a404bd24cbc35777$var$flushJobs);
    }
}
function $a404bd24cbc35777$var$flushJobs() {
    $a404bd24cbc35777$var$flushPending = false;
    $a404bd24cbc35777$var$flushing = true;
    for(let i = 0; i < $a404bd24cbc35777$var$queue.length; i++){
        $a404bd24cbc35777$var$queue[i]();
        $a404bd24cbc35777$var$lastFlushedIndex = i;
    }
    $a404bd24cbc35777$var$queue.length = 0;
    $a404bd24cbc35777$var$lastFlushedIndex = -1;
    $a404bd24cbc35777$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $a404bd24cbc35777$var$reactive;
var $a404bd24cbc35777$var$effect;
var $a404bd24cbc35777$var$release;
var $a404bd24cbc35777$var$raw;
var $a404bd24cbc35777$var$shouldSchedule = true;
function $a404bd24cbc35777$var$disableEffectScheduling(callback) {
    $a404bd24cbc35777$var$shouldSchedule = false;
    callback();
    $a404bd24cbc35777$var$shouldSchedule = true;
}
function $a404bd24cbc35777$var$setReactivityEngine(engine) {
    $a404bd24cbc35777$var$reactive = engine.reactive;
    $a404bd24cbc35777$var$release = engine.release;
    $a404bd24cbc35777$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($a404bd24cbc35777$var$shouldSchedule) $a404bd24cbc35777$var$scheduler(task);
                else task();
            }
        });
    $a404bd24cbc35777$var$raw = engine.raw;
}
function $a404bd24cbc35777$var$overrideEffect(override) {
    $a404bd24cbc35777$var$effect = override;
}
function $a404bd24cbc35777$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $a404bd24cbc35777$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $a404bd24cbc35777$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $a404bd24cbc35777$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $a404bd24cbc35777$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$a404bd24cbc35777$var$release(effectReference);
}
// packages/alpinejs/src/mutation.js
var $a404bd24cbc35777$var$onAttributeAddeds = [];
var $a404bd24cbc35777$var$onElRemoveds = [];
var $a404bd24cbc35777$var$onElAddeds = [];
function $a404bd24cbc35777$var$onElAdded(callback) {
    $a404bd24cbc35777$var$onElAddeds.push(callback);
}
function $a404bd24cbc35777$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $a404bd24cbc35777$var$onElRemoveds.push(callback);
    }
}
function $a404bd24cbc35777$var$onAttributesAdded(callback) {
    $a404bd24cbc35777$var$onAttributeAddeds.push(callback);
}
function $a404bd24cbc35777$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $a404bd24cbc35777$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $a404bd24cbc35777$var$cleanupElement(el) {
    el._x_effects?.forEach($a404bd24cbc35777$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $a404bd24cbc35777$var$observer = new MutationObserver($a404bd24cbc35777$var$onMutate);
var $a404bd24cbc35777$var$currentlyObserving = false;
function $a404bd24cbc35777$var$startObservingMutations() {
    $a404bd24cbc35777$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $a404bd24cbc35777$var$currentlyObserving = true;
}
function $a404bd24cbc35777$var$stopObservingMutations() {
    $a404bd24cbc35777$var$flushObserver();
    $a404bd24cbc35777$var$observer.disconnect();
    $a404bd24cbc35777$var$currentlyObserving = false;
}
var $a404bd24cbc35777$var$queuedMutations = [];
function $a404bd24cbc35777$var$flushObserver() {
    let records = $a404bd24cbc35777$var$observer.takeRecords();
    $a404bd24cbc35777$var$queuedMutations.push(()=>records.length > 0 && $a404bd24cbc35777$var$onMutate(records));
    let queueLengthWhenTriggered = $a404bd24cbc35777$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($a404bd24cbc35777$var$queuedMutations.length === queueLengthWhenTriggered) while($a404bd24cbc35777$var$queuedMutations.length > 0)$a404bd24cbc35777$var$queuedMutations.shift()();
    });
}
function $a404bd24cbc35777$var$mutateDom(callback) {
    if (!$a404bd24cbc35777$var$currentlyObserving) return callback();
    $a404bd24cbc35777$var$stopObservingMutations();
    let result = callback();
    $a404bd24cbc35777$var$startObservingMutations();
    return result;
}
var $a404bd24cbc35777$var$isCollecting = false;
var $a404bd24cbc35777$var$deferredMutations = [];
function $a404bd24cbc35777$var$deferMutations() {
    $a404bd24cbc35777$var$isCollecting = true;
}
function $a404bd24cbc35777$var$flushAndStopDeferringMutations() {
    $a404bd24cbc35777$var$isCollecting = false;
    $a404bd24cbc35777$var$onMutate($a404bd24cbc35777$var$deferredMutations);
    $a404bd24cbc35777$var$deferredMutations = [];
}
function $a404bd24cbc35777$var$onMutate(mutations) {
    if ($a404bd24cbc35777$var$isCollecting) {
        $a404bd24cbc35777$var$deferredMutations = $a404bd24cbc35777$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $a404bd24cbc35777$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $a404bd24cbc35777$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $a404bd24cbc35777$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $a404bd24cbc35777$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $a404bd24cbc35777$var$scope(node) {
    return $a404bd24cbc35777$var$mergeProxies($a404bd24cbc35777$var$closestDataStack(node));
}
function $a404bd24cbc35777$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$a404bd24cbc35777$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $a404bd24cbc35777$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $a404bd24cbc35777$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $a404bd24cbc35777$var$closestDataStack(node.parentNode);
}
function $a404bd24cbc35777$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $a404bd24cbc35777$var$mergeProxyTrap);
}
var $a404bd24cbc35777$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $a404bd24cbc35777$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $a404bd24cbc35777$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $a404bd24cbc35777$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $a404bd24cbc35777$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$a404bd24cbc35777$var$get(data2, path), (value)=>$a404bd24cbc35777$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $a404bd24cbc35777$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $a404bd24cbc35777$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $a404bd24cbc35777$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $a404bd24cbc35777$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $a404bd24cbc35777$var$magics = {};
function $a404bd24cbc35777$var$magic(name, callback) {
    $a404bd24cbc35777$var$magics[name] = callback;
}
function $a404bd24cbc35777$var$injectMagics(obj, el) {
    let memoizedUtilities = $a404bd24cbc35777$var$getUtilities(el);
    Object.entries($a404bd24cbc35777$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $a404bd24cbc35777$var$getUtilities(el) {
    let [utilities, cleanup2] = $a404bd24cbc35777$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $a404bd24cbc35777$var$interceptor,
        ...utilities
    };
    $a404bd24cbc35777$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $a404bd24cbc35777$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $a404bd24cbc35777$var$handleError(e, el, expression);
    }
}
function $a404bd24cbc35777$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $a404bd24cbc35777$var$shouldAutoEvaluateFunctions = true;
function $a404bd24cbc35777$var$dontAutoEvaluateFunctions(callback) {
    let cache = $a404bd24cbc35777$var$shouldAutoEvaluateFunctions;
    $a404bd24cbc35777$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $a404bd24cbc35777$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $a404bd24cbc35777$var$evaluate(el, expression, extras = {}) {
    let result;
    $a404bd24cbc35777$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $a404bd24cbc35777$var$evaluateLater(...args) {
    return $a404bd24cbc35777$var$theEvaluatorFunction(...args);
}
var $a404bd24cbc35777$var$theEvaluatorFunction = $a404bd24cbc35777$var$normalEvaluator;
function $a404bd24cbc35777$var$setEvaluator(newEvaluator) {
    $a404bd24cbc35777$var$theEvaluatorFunction = newEvaluator;
}
function $a404bd24cbc35777$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $a404bd24cbc35777$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$a404bd24cbc35777$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $a404bd24cbc35777$var$generateEvaluatorFromFunction(dataStack, expression) : $a404bd24cbc35777$var$generateEvaluatorFromString(dataStack, expression, el);
    return $a404bd24cbc35777$var$tryCatch.bind(null, el, expression, evaluator);
}
function $a404bd24cbc35777$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($a404bd24cbc35777$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $a404bd24cbc35777$var$runIfTypeOfFunction(receiver, result);
    };
}
var $a404bd24cbc35777$var$evaluatorMemo = {};
function $a404bd24cbc35777$var$generateFunctionFromString(expression, el) {
    if ($a404bd24cbc35777$var$evaluatorMemo[expression]) return $a404bd24cbc35777$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $a404bd24cbc35777$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $a404bd24cbc35777$var$evaluatorMemo[expression] = func;
    return func;
}
function $a404bd24cbc35777$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $a404bd24cbc35777$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $a404bd24cbc35777$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$a404bd24cbc35777$var$handleError(error2, el, expression));
            if (func.finished) {
                $a404bd24cbc35777$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $a404bd24cbc35777$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$a404bd24cbc35777$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $a404bd24cbc35777$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($a404bd24cbc35777$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$a404bd24cbc35777$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$a404bd24cbc35777$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $a404bd24cbc35777$var$prefixAsString = "x-";
function $a404bd24cbc35777$var$prefix(subject = "") {
    return $a404bd24cbc35777$var$prefixAsString + subject;
}
function $a404bd24cbc35777$var$setPrefix(newPrefix) {
    $a404bd24cbc35777$var$prefixAsString = newPrefix;
}
var $a404bd24cbc35777$var$directiveHandlers = {};
function $a404bd24cbc35777$var$directive(name, callback) {
    $a404bd24cbc35777$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$a404bd24cbc35777$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $a404bd24cbc35777$var$directiveOrder.indexOf(directive2);
            $a404bd24cbc35777$var$directiveOrder.splice(pos >= 0 ? pos : $a404bd24cbc35777$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $a404bd24cbc35777$var$directiveExists(name) {
    return Object.keys($a404bd24cbc35777$var$directiveHandlers).includes(name);
}
function $a404bd24cbc35777$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $a404bd24cbc35777$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($a404bd24cbc35777$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($a404bd24cbc35777$var$outNonAlpineAttributes).map($a404bd24cbc35777$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($a404bd24cbc35777$var$byPriority);
    return directives2.map((directive2)=>{
        return $a404bd24cbc35777$var$getDirectiveHandler(el, directive2);
    });
}
function $a404bd24cbc35777$var$attributesOnly(attributes) {
    return Array.from(attributes).map($a404bd24cbc35777$var$toTransformedAttributes()).filter((attr)=>!$a404bd24cbc35777$var$outNonAlpineAttributes(attr));
}
var $a404bd24cbc35777$var$isDeferringHandlers = false;
var $a404bd24cbc35777$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $a404bd24cbc35777$var$currentHandlerStackKey = Symbol();
function $a404bd24cbc35777$var$deferHandlingDirectives(callback) {
    $a404bd24cbc35777$var$isDeferringHandlers = true;
    let key = Symbol();
    $a404bd24cbc35777$var$currentHandlerStackKey = key;
    $a404bd24cbc35777$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($a404bd24cbc35777$var$directiveHandlerStacks.get(key).length)$a404bd24cbc35777$var$directiveHandlerStacks.get(key).shift()();
        $a404bd24cbc35777$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $a404bd24cbc35777$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $a404bd24cbc35777$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $a404bd24cbc35777$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $a404bd24cbc35777$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $a404bd24cbc35777$var$evaluateLater.bind($a404bd24cbc35777$var$evaluateLater, el),
        evaluate: $a404bd24cbc35777$var$evaluate.bind($a404bd24cbc35777$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $a404bd24cbc35777$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $a404bd24cbc35777$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $a404bd24cbc35777$var$getElementBoundUtilities(el);
    $a404bd24cbc35777$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $a404bd24cbc35777$var$isDeferringHandlers ? $a404bd24cbc35777$var$directiveHandlerStacks.get($a404bd24cbc35777$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $a404bd24cbc35777$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $a404bd24cbc35777$var$into = (i)=>i;
function $a404bd24cbc35777$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $a404bd24cbc35777$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $a404bd24cbc35777$var$attributeTransformers = [];
function $a404bd24cbc35777$var$mapAttributes(callback) {
    $a404bd24cbc35777$var$attributeTransformers.push(callback);
}
function $a404bd24cbc35777$var$outNonAlpineAttributes({ name: name }) {
    return $a404bd24cbc35777$var$alpineAttributeRegex().test(name);
}
var $a404bd24cbc35777$var$alpineAttributeRegex = ()=>new RegExp(`^${$a404bd24cbc35777$var$prefixAsString}([^:^.]+)\\b`);
function $a404bd24cbc35777$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($a404bd24cbc35777$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $a404bd24cbc35777$var$DEFAULT = "DEFAULT";
var $a404bd24cbc35777$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $a404bd24cbc35777$var$DEFAULT,
    "teleport"
];
function $a404bd24cbc35777$var$byPriority(a, b) {
    let typeA = $a404bd24cbc35777$var$directiveOrder.indexOf(a.type) === -1 ? $a404bd24cbc35777$var$DEFAULT : a.type;
    let typeB = $a404bd24cbc35777$var$directiveOrder.indexOf(b.type) === -1 ? $a404bd24cbc35777$var$DEFAULT : b.type;
    return $a404bd24cbc35777$var$directiveOrder.indexOf(typeA) - $a404bd24cbc35777$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $a404bd24cbc35777$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $a404bd24cbc35777$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$a404bd24cbc35777$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $a404bd24cbc35777$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $a404bd24cbc35777$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $a404bd24cbc35777$var$started = false;
function $a404bd24cbc35777$var$start() {
    if ($a404bd24cbc35777$var$started) $a404bd24cbc35777$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $a404bd24cbc35777$var$started = true;
    if (!document.body) $a404bd24cbc35777$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $a404bd24cbc35777$var$dispatch(document, "alpine:init");
    $a404bd24cbc35777$var$dispatch(document, "alpine:initializing");
    $a404bd24cbc35777$var$startObservingMutations();
    $a404bd24cbc35777$var$onElAdded((el)=>$a404bd24cbc35777$var$initTree(el, $a404bd24cbc35777$var$walk));
    $a404bd24cbc35777$var$onElRemoved((el)=>$a404bd24cbc35777$var$destroyTree(el));
    $a404bd24cbc35777$var$onAttributesAdded((el, attrs)=>{
        $a404bd24cbc35777$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$a404bd24cbc35777$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($a404bd24cbc35777$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $a404bd24cbc35777$var$initTree(el);
    });
    $a404bd24cbc35777$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $a404bd24cbc35777$var$warnAboutMissingPlugins();
    });
}
var $a404bd24cbc35777$var$rootSelectorCallbacks = [];
var $a404bd24cbc35777$var$initSelectorCallbacks = [];
function $a404bd24cbc35777$var$rootSelectors() {
    return $a404bd24cbc35777$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $a404bd24cbc35777$var$allSelectors() {
    return $a404bd24cbc35777$var$rootSelectorCallbacks.concat($a404bd24cbc35777$var$initSelectorCallbacks).map((fn)=>fn());
}
function $a404bd24cbc35777$var$addRootSelector(selectorCallback) {
    $a404bd24cbc35777$var$rootSelectorCallbacks.push(selectorCallback);
}
function $a404bd24cbc35777$var$addInitSelector(selectorCallback) {
    $a404bd24cbc35777$var$initSelectorCallbacks.push(selectorCallback);
}
function $a404bd24cbc35777$var$closestRoot(el, includeInitSelectors = false) {
    return $a404bd24cbc35777$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $a404bd24cbc35777$var$allSelectors() : $a404bd24cbc35777$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $a404bd24cbc35777$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $a404bd24cbc35777$var$findClosest(el.parentElement, callback);
}
function $a404bd24cbc35777$var$isRoot(el) {
    return $a404bd24cbc35777$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $a404bd24cbc35777$var$initInterceptors2 = [];
function $a404bd24cbc35777$var$interceptInit(callback) {
    $a404bd24cbc35777$var$initInterceptors2.push(callback);
}
var $a404bd24cbc35777$var$markerDispenser = 1;
function $a404bd24cbc35777$var$initTree(el, walker = $a404bd24cbc35777$var$walk, intercept = ()=>{}) {
    if ($a404bd24cbc35777$var$findClosest(el, (i)=>i._x_ignore)) return;
    $a404bd24cbc35777$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $a404bd24cbc35777$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $a404bd24cbc35777$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $a404bd24cbc35777$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $a404bd24cbc35777$var$destroyTree(root, walker = $a404bd24cbc35777$var$walk) {
    walker(root, (el)=>{
        $a404bd24cbc35777$var$cleanupElement(el);
        $a404bd24cbc35777$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $a404bd24cbc35777$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($a404bd24cbc35777$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $a404bd24cbc35777$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $a404bd24cbc35777$var$tickStack = [];
var $a404bd24cbc35777$var$isHolding = false;
function $a404bd24cbc35777$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $a404bd24cbc35777$var$isHolding || setTimeout(()=>{
            $a404bd24cbc35777$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $a404bd24cbc35777$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $a404bd24cbc35777$var$releaseNextTicks() {
    $a404bd24cbc35777$var$isHolding = false;
    while($a404bd24cbc35777$var$tickStack.length)$a404bd24cbc35777$var$tickStack.shift()();
}
function $a404bd24cbc35777$var$holdNextTicks() {
    $a404bd24cbc35777$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $a404bd24cbc35777$var$setClasses(el, value) {
    if (Array.isArray(value)) return $a404bd24cbc35777$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $a404bd24cbc35777$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $a404bd24cbc35777$var$setClasses(el, value());
    return $a404bd24cbc35777$var$setClassesFromString(el, value);
}
function $a404bd24cbc35777$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $a404bd24cbc35777$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $a404bd24cbc35777$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $a404bd24cbc35777$var$setStylesFromObject(el, value);
    return $a404bd24cbc35777$var$setStylesFromString(el, value);
}
function $a404bd24cbc35777$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $a404bd24cbc35777$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $a404bd24cbc35777$var$setStyles(el, previousStyles);
    };
}
function $a404bd24cbc35777$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $a404bd24cbc35777$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $a404bd24cbc35777$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$a404bd24cbc35777$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $a404bd24cbc35777$var$registerTransitionsFromHelper(el, modifiers, value);
    else $a404bd24cbc35777$var$registerTransitionsFromClassString(el, expression, value);
});
function $a404bd24cbc35777$var$registerTransitionsFromClassString(el, classString, stage) {
    $a404bd24cbc35777$var$registerTransitionObject(el, $a404bd24cbc35777$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $a404bd24cbc35777$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $a404bd24cbc35777$var$registerTransitionObject(el, $a404bd24cbc35777$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $a404bd24cbc35777$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $a404bd24cbc35777$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $a404bd24cbc35777$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $a404bd24cbc35777$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $a404bd24cbc35777$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $a404bd24cbc35777$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $a404bd24cbc35777$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $a404bd24cbc35777$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $a404bd24cbc35777$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $a404bd24cbc35777$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $a404bd24cbc35777$var$closestHide(parent);
}
function $a404bd24cbc35777$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $a404bd24cbc35777$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $a404bd24cbc35777$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $a404bd24cbc35777$var$once(()=>{
        $a404bd24cbc35777$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $a404bd24cbc35777$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $a404bd24cbc35777$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $a404bd24cbc35777$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $a404bd24cbc35777$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $a404bd24cbc35777$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $a404bd24cbc35777$var$mutateDom(()=>{
                stages.end();
            });
            $a404bd24cbc35777$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $a404bd24cbc35777$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $a404bd24cbc35777$var$isCloning = false;
function $a404bd24cbc35777$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$a404bd24cbc35777$var$isCloning ? fallback(...args) : callback(...args);
}
function $a404bd24cbc35777$var$onlyDuringClone(callback) {
    return (...args)=>$a404bd24cbc35777$var$isCloning && callback(...args);
}
var $a404bd24cbc35777$var$interceptors = [];
function $a404bd24cbc35777$var$interceptClone(callback) {
    $a404bd24cbc35777$var$interceptors.push(callback);
}
function $a404bd24cbc35777$var$cloneNode(from, to) {
    $a404bd24cbc35777$var$interceptors.forEach((i)=>i(from, to));
    $a404bd24cbc35777$var$isCloning = true;
    $a404bd24cbc35777$var$dontRegisterReactiveSideEffects(()=>{
        $a404bd24cbc35777$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $a404bd24cbc35777$var$isCloning = false;
}
var $a404bd24cbc35777$var$isCloningLegacy = false;
function $a404bd24cbc35777$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $a404bd24cbc35777$var$isCloning = true;
    $a404bd24cbc35777$var$isCloningLegacy = true;
    $a404bd24cbc35777$var$dontRegisterReactiveSideEffects(()=>{
        $a404bd24cbc35777$var$cloneTree(newEl);
    });
    $a404bd24cbc35777$var$isCloning = false;
    $a404bd24cbc35777$var$isCloningLegacy = false;
}
function $a404bd24cbc35777$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $a404bd24cbc35777$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $a404bd24cbc35777$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $a404bd24cbc35777$var$initTree(el, shallowWalker);
}
function $a404bd24cbc35777$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $a404bd24cbc35777$var$effect;
    $a404bd24cbc35777$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $a404bd24cbc35777$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $a404bd24cbc35777$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $a404bd24cbc35777$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $a404bd24cbc35777$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $a404bd24cbc35777$var$camelCase(name) : name;
    switch(name){
        case "value":
            $a404bd24cbc35777$var$bindInputValue(el, value);
            break;
        case "style":
            $a404bd24cbc35777$var$bindStyles(el, value);
            break;
        case "class":
            $a404bd24cbc35777$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $a404bd24cbc35777$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $a404bd24cbc35777$var$bindAttribute(el, name, value);
            break;
    }
}
function $a404bd24cbc35777$var$bindInputValue(el, value) {
    if ($a404bd24cbc35777$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $a404bd24cbc35777$var$safeParseBoolean(el.value) === value;
            else el.checked = $a404bd24cbc35777$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($a404bd24cbc35777$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$a404bd24cbc35777$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $a404bd24cbc35777$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $a404bd24cbc35777$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $a404bd24cbc35777$var$setClasses(el, value);
}
function $a404bd24cbc35777$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $a404bd24cbc35777$var$setStyles(el, value);
}
function $a404bd24cbc35777$var$bindAttributeAndProperty(el, name, value) {
    $a404bd24cbc35777$var$bindAttribute(el, name, value);
    $a404bd24cbc35777$var$setPropertyIfChanged(el, name, value);
}
function $a404bd24cbc35777$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $a404bd24cbc35777$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($a404bd24cbc35777$var$isBooleanAttr(name)) value = name;
        $a404bd24cbc35777$var$setIfChanged(el, name, value);
    }
}
function $a404bd24cbc35777$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $a404bd24cbc35777$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $a404bd24cbc35777$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $a404bd24cbc35777$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $a404bd24cbc35777$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $a404bd24cbc35777$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $a404bd24cbc35777$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $a404bd24cbc35777$var$isBooleanAttr(attrName) {
    return $a404bd24cbc35777$var$booleanAttributes.has(attrName);
}
function $a404bd24cbc35777$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $a404bd24cbc35777$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $a404bd24cbc35777$var$getAttributeBinding(el, name, fallback);
}
function $a404bd24cbc35777$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $a404bd24cbc35777$var$dontAutoEvaluateFunctions(()=>{
            return $a404bd24cbc35777$var$evaluate(el, binding.expression);
        });
    }
    return $a404bd24cbc35777$var$getAttributeBinding(el, name, fallback);
}
function $a404bd24cbc35777$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($a404bd24cbc35777$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $a404bd24cbc35777$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $a404bd24cbc35777$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $a404bd24cbc35777$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $a404bd24cbc35777$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $a404bd24cbc35777$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $a404bd24cbc35777$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($a404bd24cbc35777$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($a404bd24cbc35777$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($a404bd24cbc35777$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $a404bd24cbc35777$var$release(reference);
    };
}
function $a404bd24cbc35777$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $a404bd24cbc35777$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($a404bd24cbc35777$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $a404bd24cbc35777$var$stores = {};
var $a404bd24cbc35777$var$isReactive = false;
function $a404bd24cbc35777$var$store(name, value) {
    if (!$a404bd24cbc35777$var$isReactive) {
        $a404bd24cbc35777$var$stores = $a404bd24cbc35777$var$reactive($a404bd24cbc35777$var$stores);
        $a404bd24cbc35777$var$isReactive = true;
    }
    if (value === void 0) return $a404bd24cbc35777$var$stores[name];
    $a404bd24cbc35777$var$stores[name] = value;
    $a404bd24cbc35777$var$initInterceptors($a404bd24cbc35777$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $a404bd24cbc35777$var$stores[name].init();
}
function $a404bd24cbc35777$var$getStores() {
    return $a404bd24cbc35777$var$stores;
}
// packages/alpinejs/src/binds.js
var $a404bd24cbc35777$var$binds = {};
function $a404bd24cbc35777$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $a404bd24cbc35777$var$applyBindingsObject(name, getBindings());
    else $a404bd24cbc35777$var$binds[name] = getBindings;
    return ()=>{};
}
function $a404bd24cbc35777$var$injectBindingProviders(obj) {
    Object.entries($a404bd24cbc35777$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $a404bd24cbc35777$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $a404bd24cbc35777$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $a404bd24cbc35777$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $a404bd24cbc35777$var$datas = {};
function $a404bd24cbc35777$var$data(name, callback) {
    $a404bd24cbc35777$var$datas[name] = callback;
}
function $a404bd24cbc35777$var$injectDataProviders(obj, context) {
    Object.entries($a404bd24cbc35777$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $a404bd24cbc35777$var$Alpine = {
    get reactive () {
        return $a404bd24cbc35777$var$reactive;
    },
    get release () {
        return $a404bd24cbc35777$var$release;
    },
    get effect () {
        return $a404bd24cbc35777$var$effect;
    },
    get raw () {
        return $a404bd24cbc35777$var$raw;
    },
    version: "3.14.8",
    flushAndStopDeferringMutations: $a404bd24cbc35777$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $a404bd24cbc35777$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $a404bd24cbc35777$var$disableEffectScheduling,
    startObservingMutations: $a404bd24cbc35777$var$startObservingMutations,
    stopObservingMutations: $a404bd24cbc35777$var$stopObservingMutations,
    setReactivityEngine: $a404bd24cbc35777$var$setReactivityEngine,
    onAttributeRemoved: $a404bd24cbc35777$var$onAttributeRemoved,
    onAttributesAdded: $a404bd24cbc35777$var$onAttributesAdded,
    closestDataStack: $a404bd24cbc35777$var$closestDataStack,
    skipDuringClone: $a404bd24cbc35777$var$skipDuringClone,
    onlyDuringClone: $a404bd24cbc35777$var$onlyDuringClone,
    addRootSelector: $a404bd24cbc35777$var$addRootSelector,
    addInitSelector: $a404bd24cbc35777$var$addInitSelector,
    interceptClone: $a404bd24cbc35777$var$interceptClone,
    addScopeToNode: $a404bd24cbc35777$var$addScopeToNode,
    deferMutations: $a404bd24cbc35777$var$deferMutations,
    mapAttributes: $a404bd24cbc35777$var$mapAttributes,
    evaluateLater: $a404bd24cbc35777$var$evaluateLater,
    interceptInit: $a404bd24cbc35777$var$interceptInit,
    setEvaluator: $a404bd24cbc35777$var$setEvaluator,
    mergeProxies: $a404bd24cbc35777$var$mergeProxies,
    extractProp: $a404bd24cbc35777$var$extractProp,
    findClosest: $a404bd24cbc35777$var$findClosest,
    onElRemoved: $a404bd24cbc35777$var$onElRemoved,
    closestRoot: $a404bd24cbc35777$var$closestRoot,
    destroyTree: $a404bd24cbc35777$var$destroyTree,
    interceptor: $a404bd24cbc35777$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $a404bd24cbc35777$var$transition,
    setStyles: // INTERNAL
    $a404bd24cbc35777$var$setStyles,
    mutateDom: // INTERNAL
    $a404bd24cbc35777$var$mutateDom,
    directive: $a404bd24cbc35777$var$directive,
    entangle: $a404bd24cbc35777$var$entangle,
    throttle: $a404bd24cbc35777$var$throttle,
    debounce: $a404bd24cbc35777$var$debounce,
    evaluate: $a404bd24cbc35777$var$evaluate,
    initTree: $a404bd24cbc35777$var$initTree,
    nextTick: $a404bd24cbc35777$var$nextTick,
    prefixed: $a404bd24cbc35777$var$prefix,
    prefix: $a404bd24cbc35777$var$setPrefix,
    plugin: $a404bd24cbc35777$var$plugin,
    magic: $a404bd24cbc35777$var$magic,
    store: $a404bd24cbc35777$var$store,
    start: $a404bd24cbc35777$var$start,
    clone: $a404bd24cbc35777$var$clone,
    cloneNode: // INTERNAL
    $a404bd24cbc35777$var$cloneNode,
    // INTERNAL
    bound: $a404bd24cbc35777$var$getBinding,
    $data: $a404bd24cbc35777$var$scope,
    watch: $a404bd24cbc35777$var$watch,
    walk: $a404bd24cbc35777$var$walk,
    data: $a404bd24cbc35777$var$data,
    bind: $a404bd24cbc35777$var$bind2
};
var $a404bd24cbc35777$var$alpine_default = $a404bd24cbc35777$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $a404bd24cbc35777$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $a404bd24cbc35777$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $a404bd24cbc35777$var$isBooleanAttr2 = /* @__PURE__ */ $a404bd24cbc35777$var$makeMap($a404bd24cbc35777$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $a404bd24cbc35777$var$EMPTY_OBJ = Object.freeze({});
var $a404bd24cbc35777$var$EMPTY_ARR = Object.freeze([]);
var $a404bd24cbc35777$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $a404bd24cbc35777$var$hasOwn = (val, key)=>$a404bd24cbc35777$var$hasOwnProperty.call(val, key);
var $a404bd24cbc35777$var$isArray = Array.isArray;
var $a404bd24cbc35777$var$isMap = (val)=>$a404bd24cbc35777$var$toTypeString(val) === "[object Map]";
var $a404bd24cbc35777$var$isString = (val)=>typeof val === "string";
var $a404bd24cbc35777$var$isSymbol = (val)=>typeof val === "symbol";
var $a404bd24cbc35777$var$isObject = (val)=>val !== null && typeof val === "object";
var $a404bd24cbc35777$var$objectToString = Object.prototype.toString;
var $a404bd24cbc35777$var$toTypeString = (value)=>$a404bd24cbc35777$var$objectToString.call(value);
var $a404bd24cbc35777$var$toRawType = (value)=>{
    return $a404bd24cbc35777$var$toTypeString(value).slice(8, -1);
};
var $a404bd24cbc35777$var$isIntegerKey = (key)=>$a404bd24cbc35777$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $a404bd24cbc35777$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $a404bd24cbc35777$var$camelizeRE = /-(\w)/g;
var $a404bd24cbc35777$var$camelize = $a404bd24cbc35777$var$cacheStringFunction((str)=>{
    return str.replace($a404bd24cbc35777$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $a404bd24cbc35777$var$hyphenateRE = /\B([A-Z])/g;
var $a404bd24cbc35777$var$hyphenate = $a404bd24cbc35777$var$cacheStringFunction((str)=>str.replace($a404bd24cbc35777$var$hyphenateRE, "-$1").toLowerCase());
var $a404bd24cbc35777$var$capitalize = $a404bd24cbc35777$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $a404bd24cbc35777$var$toHandlerKey = $a404bd24cbc35777$var$cacheStringFunction((str)=>str ? `on${$a404bd24cbc35777$var$capitalize(str)}` : ``);
var $a404bd24cbc35777$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $a404bd24cbc35777$var$targetMap = /* @__PURE__ */ new WeakMap();
var $a404bd24cbc35777$var$effectStack = [];
var $a404bd24cbc35777$var$activeEffect;
var $a404bd24cbc35777$var$ITERATE_KEY = Symbol("iterate");
var $a404bd24cbc35777$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $a404bd24cbc35777$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $a404bd24cbc35777$var$effect2(fn, options = $a404bd24cbc35777$var$EMPTY_OBJ) {
    if ($a404bd24cbc35777$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $a404bd24cbc35777$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $a404bd24cbc35777$var$stop(effect3) {
    if (effect3.active) {
        $a404bd24cbc35777$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $a404bd24cbc35777$var$uid = 0;
function $a404bd24cbc35777$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$a404bd24cbc35777$var$effectStack.includes(effect3)) {
            $a404bd24cbc35777$var$cleanup(effect3);
            try {
                $a404bd24cbc35777$var$enableTracking();
                $a404bd24cbc35777$var$effectStack.push(effect3);
                $a404bd24cbc35777$var$activeEffect = effect3;
                return fn();
            } finally{
                $a404bd24cbc35777$var$effectStack.pop();
                $a404bd24cbc35777$var$resetTracking();
                $a404bd24cbc35777$var$activeEffect = $a404bd24cbc35777$var$effectStack[$a404bd24cbc35777$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $a404bd24cbc35777$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $a404bd24cbc35777$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $a404bd24cbc35777$var$shouldTrack = true;
var $a404bd24cbc35777$var$trackStack = [];
function $a404bd24cbc35777$var$pauseTracking() {
    $a404bd24cbc35777$var$trackStack.push($a404bd24cbc35777$var$shouldTrack);
    $a404bd24cbc35777$var$shouldTrack = false;
}
function $a404bd24cbc35777$var$enableTracking() {
    $a404bd24cbc35777$var$trackStack.push($a404bd24cbc35777$var$shouldTrack);
    $a404bd24cbc35777$var$shouldTrack = true;
}
function $a404bd24cbc35777$var$resetTracking() {
    const last = $a404bd24cbc35777$var$trackStack.pop();
    $a404bd24cbc35777$var$shouldTrack = last === void 0 ? true : last;
}
function $a404bd24cbc35777$var$track(target, type, key) {
    if (!$a404bd24cbc35777$var$shouldTrack || $a404bd24cbc35777$var$activeEffect === void 0) return;
    let depsMap = $a404bd24cbc35777$var$targetMap.get(target);
    if (!depsMap) $a404bd24cbc35777$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($a404bd24cbc35777$var$activeEffect)) {
        dep.add($a404bd24cbc35777$var$activeEffect);
        $a404bd24cbc35777$var$activeEffect.deps.push(dep);
        if ($a404bd24cbc35777$var$activeEffect.options.onTrack) $a404bd24cbc35777$var$activeEffect.options.onTrack({
            effect: $a404bd24cbc35777$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $a404bd24cbc35777$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $a404bd24cbc35777$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $a404bd24cbc35777$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $a404bd24cbc35777$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$a404bd24cbc35777$var$isArray(target)) {
                    add2(depsMap.get($a404bd24cbc35777$var$ITERATE_KEY));
                    if ($a404bd24cbc35777$var$isMap(target)) add2(depsMap.get($a404bd24cbc35777$var$MAP_KEY_ITERATE_KEY));
                } else if ($a404bd24cbc35777$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$a404bd24cbc35777$var$isArray(target)) {
                    add2(depsMap.get($a404bd24cbc35777$var$ITERATE_KEY));
                    if ($a404bd24cbc35777$var$isMap(target)) add2(depsMap.get($a404bd24cbc35777$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($a404bd24cbc35777$var$isMap(target)) add2(depsMap.get($a404bd24cbc35777$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $a404bd24cbc35777$var$isNonTrackableKeys = /* @__PURE__ */ $a404bd24cbc35777$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $a404bd24cbc35777$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($a404bd24cbc35777$var$isSymbol));
var $a404bd24cbc35777$var$get2 = /* @__PURE__ */ $a404bd24cbc35777$var$createGetter();
var $a404bd24cbc35777$var$readonlyGet = /* @__PURE__ */ $a404bd24cbc35777$var$createGetter(true);
var $a404bd24cbc35777$var$arrayInstrumentations = /* @__PURE__ */ $a404bd24cbc35777$var$createArrayInstrumentations();
function $a404bd24cbc35777$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $a404bd24cbc35777$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$a404bd24cbc35777$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($a404bd24cbc35777$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $a404bd24cbc35777$var$pauseTracking();
            const res = $a404bd24cbc35777$var$toRaw(this)[key].apply(this, args);
            $a404bd24cbc35777$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $a404bd24cbc35777$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $a404bd24cbc35777$var$shallowReadonlyMap : $a404bd24cbc35777$var$readonlyMap : shallow ? $a404bd24cbc35777$var$shallowReactiveMap : $a404bd24cbc35777$var$reactiveMap).get(target)) return target;
        const targetIsArray = $a404bd24cbc35777$var$isArray(target);
        if (!isReadonly && targetIsArray && $a404bd24cbc35777$var$hasOwn($a404bd24cbc35777$var$arrayInstrumentations, key)) return Reflect.get($a404bd24cbc35777$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($a404bd24cbc35777$var$isSymbol(key) ? $a404bd24cbc35777$var$builtInSymbols.has(key) : $a404bd24cbc35777$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $a404bd24cbc35777$var$track(target, "get", key);
        if (shallow) return res;
        if ($a404bd24cbc35777$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$a404bd24cbc35777$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($a404bd24cbc35777$var$isObject(res)) return isReadonly ? $a404bd24cbc35777$var$readonly(res) : $a404bd24cbc35777$var$reactive2(res);
        return res;
    };
}
var $a404bd24cbc35777$var$set2 = /* @__PURE__ */ $a404bd24cbc35777$var$createSetter();
function $a404bd24cbc35777$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $a404bd24cbc35777$var$toRaw(value);
            oldValue = $a404bd24cbc35777$var$toRaw(oldValue);
            if (!$a404bd24cbc35777$var$isArray(target) && $a404bd24cbc35777$var$isRef(oldValue) && !$a404bd24cbc35777$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $a404bd24cbc35777$var$isArray(target) && $a404bd24cbc35777$var$isIntegerKey(key) ? Number(key) < target.length : $a404bd24cbc35777$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $a404bd24cbc35777$var$toRaw(receiver)) {
            if (!hadKey) $a404bd24cbc35777$var$trigger(target, "add", key, value);
            else if ($a404bd24cbc35777$var$hasChanged(value, oldValue)) $a404bd24cbc35777$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $a404bd24cbc35777$var$deleteProperty(target, key) {
    const hadKey = $a404bd24cbc35777$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $a404bd24cbc35777$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $a404bd24cbc35777$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$a404bd24cbc35777$var$isSymbol(key) || !$a404bd24cbc35777$var$builtInSymbols.has(key)) $a404bd24cbc35777$var$track(target, "has", key);
    return result;
}
function $a404bd24cbc35777$var$ownKeys(target) {
    $a404bd24cbc35777$var$track(target, "iterate", $a404bd24cbc35777$var$isArray(target) ? "length" : $a404bd24cbc35777$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $a404bd24cbc35777$var$mutableHandlers = {
    get: $a404bd24cbc35777$var$get2,
    set: $a404bd24cbc35777$var$set2,
    deleteProperty: $a404bd24cbc35777$var$deleteProperty,
    has: $a404bd24cbc35777$var$has,
    ownKeys: $a404bd24cbc35777$var$ownKeys
};
var $a404bd24cbc35777$var$readonlyHandlers = {
    get: $a404bd24cbc35777$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $a404bd24cbc35777$var$toReactive = (value)=>$a404bd24cbc35777$var$isObject(value) ? $a404bd24cbc35777$var$reactive2(value) : value;
var $a404bd24cbc35777$var$toReadonly = (value)=>$a404bd24cbc35777$var$isObject(value) ? $a404bd24cbc35777$var$readonly(value) : value;
var $a404bd24cbc35777$var$toShallow = (value)=>value;
var $a404bd24cbc35777$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $a404bd24cbc35777$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $a404bd24cbc35777$var$toRaw(target);
    const rawKey = $a404bd24cbc35777$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $a404bd24cbc35777$var$track(rawTarget, "get", key);
    !isReadonly && $a404bd24cbc35777$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $a404bd24cbc35777$var$getProto(rawTarget);
    const wrap = isShallow ? $a404bd24cbc35777$var$toShallow : isReadonly ? $a404bd24cbc35777$var$toReadonly : $a404bd24cbc35777$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $a404bd24cbc35777$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $a404bd24cbc35777$var$toRaw(target);
    const rawKey = $a404bd24cbc35777$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $a404bd24cbc35777$var$track(rawTarget, "has", key);
    !isReadonly && $a404bd24cbc35777$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $a404bd24cbc35777$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $a404bd24cbc35777$var$track($a404bd24cbc35777$var$toRaw(target), "iterate", $a404bd24cbc35777$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $a404bd24cbc35777$var$add(value) {
    value = $a404bd24cbc35777$var$toRaw(value);
    const target = $a404bd24cbc35777$var$toRaw(this);
    const proto = $a404bd24cbc35777$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $a404bd24cbc35777$var$trigger(target, "add", value, value);
    }
    return this;
}
function $a404bd24cbc35777$var$set$1(key, value) {
    value = $a404bd24cbc35777$var$toRaw(value);
    const target = $a404bd24cbc35777$var$toRaw(this);
    const { has: has2, get: get3 } = $a404bd24cbc35777$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $a404bd24cbc35777$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $a404bd24cbc35777$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $a404bd24cbc35777$var$trigger(target, "add", key, value);
    else if ($a404bd24cbc35777$var$hasChanged(value, oldValue)) $a404bd24cbc35777$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $a404bd24cbc35777$var$deleteEntry(key) {
    const target = $a404bd24cbc35777$var$toRaw(this);
    const { has: has2, get: get3 } = $a404bd24cbc35777$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $a404bd24cbc35777$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $a404bd24cbc35777$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $a404bd24cbc35777$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $a404bd24cbc35777$var$clear() {
    const target = $a404bd24cbc35777$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $a404bd24cbc35777$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $a404bd24cbc35777$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $a404bd24cbc35777$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $a404bd24cbc35777$var$toRaw(target);
        const wrap = isShallow ? $a404bd24cbc35777$var$toShallow : isReadonly ? $a404bd24cbc35777$var$toReadonly : $a404bd24cbc35777$var$toReactive;
        !isReadonly && $a404bd24cbc35777$var$track(rawTarget, "iterate", $a404bd24cbc35777$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $a404bd24cbc35777$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $a404bd24cbc35777$var$toRaw(target);
        const targetIsMap = $a404bd24cbc35777$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $a404bd24cbc35777$var$toShallow : isReadonly ? $a404bd24cbc35777$var$toReadonly : $a404bd24cbc35777$var$toReactive;
        !isReadonly && $a404bd24cbc35777$var$track(rawTarget, "iterate", isKeyOnly ? $a404bd24cbc35777$var$MAP_KEY_ITERATE_KEY : $a404bd24cbc35777$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $a404bd24cbc35777$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$a404bd24cbc35777$var$capitalize(type)} operation ${key}failed: target is readonly.`, $a404bd24cbc35777$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $a404bd24cbc35777$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $a404bd24cbc35777$var$get$1(this, key);
        },
        get size () {
            return $a404bd24cbc35777$var$size(this);
        },
        has: $a404bd24cbc35777$var$has$1,
        add: $a404bd24cbc35777$var$add,
        set: $a404bd24cbc35777$var$set$1,
        delete: $a404bd24cbc35777$var$deleteEntry,
        clear: $a404bd24cbc35777$var$clear,
        forEach: $a404bd24cbc35777$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $a404bd24cbc35777$var$get$1(this, key, false, true);
        },
        get size () {
            return $a404bd24cbc35777$var$size(this);
        },
        has: $a404bd24cbc35777$var$has$1,
        add: $a404bd24cbc35777$var$add,
        set: $a404bd24cbc35777$var$set$1,
        delete: $a404bd24cbc35777$var$deleteEntry,
        clear: $a404bd24cbc35777$var$clear,
        forEach: $a404bd24cbc35777$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $a404bd24cbc35777$var$get$1(this, key, true);
        },
        get size () {
            return $a404bd24cbc35777$var$size(this, true);
        },
        has (key) {
            return $a404bd24cbc35777$var$has$1.call(this, key, true);
        },
        add: $a404bd24cbc35777$var$createReadonlyMethod("add"),
        set: $a404bd24cbc35777$var$createReadonlyMethod("set"),
        delete: $a404bd24cbc35777$var$createReadonlyMethod("delete"),
        clear: $a404bd24cbc35777$var$createReadonlyMethod("clear"),
        forEach: $a404bd24cbc35777$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $a404bd24cbc35777$var$get$1(this, key, true, true);
        },
        get size () {
            return $a404bd24cbc35777$var$size(this, true);
        },
        has (key) {
            return $a404bd24cbc35777$var$has$1.call(this, key, true);
        },
        add: $a404bd24cbc35777$var$createReadonlyMethod("add"),
        set: $a404bd24cbc35777$var$createReadonlyMethod("set"),
        delete: $a404bd24cbc35777$var$createReadonlyMethod("delete"),
        clear: $a404bd24cbc35777$var$createReadonlyMethod("clear"),
        forEach: $a404bd24cbc35777$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $a404bd24cbc35777$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $a404bd24cbc35777$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $a404bd24cbc35777$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $a404bd24cbc35777$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$a404bd24cbc35777$var$mutableInstrumentations, $a404bd24cbc35777$var$readonlyInstrumentations, $a404bd24cbc35777$var$shallowInstrumentations, $a404bd24cbc35777$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $a404bd24cbc35777$var$createInstrumentations();
function $a404bd24cbc35777$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $a404bd24cbc35777$var$shallowReadonlyInstrumentations : $a404bd24cbc35777$var$shallowInstrumentations : isReadonly ? $a404bd24cbc35777$var$readonlyInstrumentations : $a404bd24cbc35777$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($a404bd24cbc35777$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $a404bd24cbc35777$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $a404bd24cbc35777$var$createInstrumentationGetter(false, false)
};
var $a404bd24cbc35777$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $a404bd24cbc35777$var$createInstrumentationGetter(true, false)
};
function $a404bd24cbc35777$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $a404bd24cbc35777$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $a404bd24cbc35777$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $a404bd24cbc35777$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $a404bd24cbc35777$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $a404bd24cbc35777$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $a404bd24cbc35777$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $a404bd24cbc35777$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $a404bd24cbc35777$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $a404bd24cbc35777$var$targetTypeMap($a404bd24cbc35777$var$toRawType(value));
}
function $a404bd24cbc35777$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $a404bd24cbc35777$var$createReactiveObject(target, false, $a404bd24cbc35777$var$mutableHandlers, $a404bd24cbc35777$var$mutableCollectionHandlers, $a404bd24cbc35777$var$reactiveMap);
}
function $a404bd24cbc35777$var$readonly(target) {
    return $a404bd24cbc35777$var$createReactiveObject(target, true, $a404bd24cbc35777$var$readonlyHandlers, $a404bd24cbc35777$var$readonlyCollectionHandlers, $a404bd24cbc35777$var$readonlyMap);
}
function $a404bd24cbc35777$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$a404bd24cbc35777$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $a404bd24cbc35777$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $a404bd24cbc35777$var$toRaw(observed) {
    return observed && $a404bd24cbc35777$var$toRaw(observed["__v_raw"]) || observed;
}
function $a404bd24cbc35777$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$a404bd24cbc35777$var$magic("nextTick", ()=>$a404bd24cbc35777$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$a404bd24cbc35777$var$magic("dispatch", (el)=>$a404bd24cbc35777$var$dispatch.bind($a404bd24cbc35777$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$a404bd24cbc35777$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $a404bd24cbc35777$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$a404bd24cbc35777$var$magic("store", $a404bd24cbc35777$var$getStores);
// packages/alpinejs/src/magics/$data.js
$a404bd24cbc35777$var$magic("data", (el)=>$a404bd24cbc35777$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$a404bd24cbc35777$var$magic("root", (el)=>$a404bd24cbc35777$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$a404bd24cbc35777$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $a404bd24cbc35777$var$mergeProxies($a404bd24cbc35777$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $a404bd24cbc35777$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $a404bd24cbc35777$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $a404bd24cbc35777$var$globalIdMemo = {};
function $a404bd24cbc35777$var$findAndIncrementId(name) {
    if (!$a404bd24cbc35777$var$globalIdMemo[name]) $a404bd24cbc35777$var$globalIdMemo[name] = 0;
    return ++$a404bd24cbc35777$var$globalIdMemo[name];
}
function $a404bd24cbc35777$var$closestIdRoot(el, name) {
    return $a404bd24cbc35777$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $a404bd24cbc35777$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $a404bd24cbc35777$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$a404bd24cbc35777$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $a404bd24cbc35777$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $a404bd24cbc35777$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $a404bd24cbc35777$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$a404bd24cbc35777$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $a404bd24cbc35777$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$a404bd24cbc35777$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$a404bd24cbc35777$var$warnMissingPluginMagic("Focus", "focus", "focus");
$a404bd24cbc35777$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $a404bd24cbc35777$var$warnMissingPluginMagic(name, magicName, slug) {
    $a404bd24cbc35777$var$magic(magicName, (el)=>$a404bd24cbc35777$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$a404bd24cbc35777$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $a404bd24cbc35777$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$a404bd24cbc35777$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $a404bd24cbc35777$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $a404bd24cbc35777$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $a404bd24cbc35777$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $a404bd24cbc35777$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $a404bd24cbc35777$var$skipDuringClone(()=>{
            $a404bd24cbc35777$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $a404bd24cbc35777$var$getTarget(expression);
        $a404bd24cbc35777$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$a404bd24cbc35777$var$mutateDom(()=>{
            clone2.remove();
            $a404bd24cbc35777$var$destroyTree(clone2);
        }));
});
var $a404bd24cbc35777$var$teleportContainerDuringClone = document.createElement("div");
function $a404bd24cbc35777$var$getTarget(expression) {
    let target = $a404bd24cbc35777$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $a404bd24cbc35777$var$teleportContainerDuringClone;
    })();
    if (!target) $a404bd24cbc35777$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $a404bd24cbc35777$var$handler = ()=>{};
$a404bd24cbc35777$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$a404bd24cbc35777$var$directive("ignore", $a404bd24cbc35777$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$a404bd24cbc35777$var$directive("effect", $a404bd24cbc35777$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($a404bd24cbc35777$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $a404bd24cbc35777$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $a404bd24cbc35777$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $a404bd24cbc35777$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $a404bd24cbc35777$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $a404bd24cbc35777$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $a404bd24cbc35777$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $a404bd24cbc35777$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if ($a404bd24cbc35777$var$isKeyEvent(event) || $a404bd24cbc35777$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($a404bd24cbc35777$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $a404bd24cbc35777$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $a404bd24cbc35777$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $a404bd24cbc35777$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $a404bd24cbc35777$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $a404bd24cbc35777$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $a404bd24cbc35777$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $a404bd24cbc35777$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $a404bd24cbc35777$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $a404bd24cbc35777$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $a404bd24cbc35777$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($a404bd24cbc35777$var$isClickEvent(e.type)) return false;
            if ($a404bd24cbc35777$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $a404bd24cbc35777$var$keyToModifiers(key) {
    if (!key) return [];
    key = $a404bd24cbc35777$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$a404bd24cbc35777$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $a404bd24cbc35777$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $a404bd24cbc35777$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $a404bd24cbc35777$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $a404bd24cbc35777$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($a404bd24cbc35777$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $a404bd24cbc35777$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $a404bd24cbc35777$var$isCloning ? ()=>{} : $a404bd24cbc35777$var$on(el, event, modifiers, (e)=>{
        setValue($a404bd24cbc35777$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $a404bd24cbc35777$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($a404bd24cbc35777$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $a404bd24cbc35777$var$on(el.form, "reset", [], (e)=>{
            $a404bd24cbc35777$var$nextTick(()=>el._x_model && el._x_model.set($a404bd24cbc35777$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $a404bd24cbc35777$var$mutateDom(()=>$a404bd24cbc35777$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $a404bd24cbc35777$var$getInputValue(el, modifiers, event, currentValue) {
    return $a404bd24cbc35777$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($a404bd24cbc35777$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $a404bd24cbc35777$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $a404bd24cbc35777$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$a404bd24cbc35777$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $a404bd24cbc35777$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $a404bd24cbc35777$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($a404bd24cbc35777$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $a404bd24cbc35777$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $a404bd24cbc35777$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $a404bd24cbc35777$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $a404bd24cbc35777$var$isNumeric2(number) ? number : rawValue;
}
function $a404bd24cbc35777$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $a404bd24cbc35777$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $a404bd24cbc35777$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$a404bd24cbc35777$var$directive("cloak", (el)=>queueMicrotask(()=>$a404bd24cbc35777$var$mutateDom(()=>el.removeAttribute($a404bd24cbc35777$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$a404bd24cbc35777$var$addInitSelector(()=>`[${$a404bd24cbc35777$var$prefix("init")}]`);
$a404bd24cbc35777$var$directive("init", $a404bd24cbc35777$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$a404bd24cbc35777$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $a404bd24cbc35777$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$a404bd24cbc35777$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $a404bd24cbc35777$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $a404bd24cbc35777$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$a404bd24cbc35777$var$mapAttributes($a404bd24cbc35777$var$startingWith(":", $a404bd24cbc35777$var$into($a404bd24cbc35777$var$prefix("bind:"))));
var $a404bd24cbc35777$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $a404bd24cbc35777$var$injectBindingProviders(bindingProviders);
        let getBindings = $a404bd24cbc35777$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $a404bd24cbc35777$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $a404bd24cbc35777$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $a404bd24cbc35777$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $a404bd24cbc35777$var$mutateDom(()=>$a404bd24cbc35777$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$a404bd24cbc35777$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$a404bd24cbc35777$var$directive("bind", $a404bd24cbc35777$var$handler2);
function $a404bd24cbc35777$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$a404bd24cbc35777$var$addRootSelector(()=>`[${$a404bd24cbc35777$var$prefix("data")}]`);
$a404bd24cbc35777$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($a404bd24cbc35777$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $a404bd24cbc35777$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $a404bd24cbc35777$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $a404bd24cbc35777$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $a404bd24cbc35777$var$injectMagics(data2, el);
    let reactiveData = $a404bd24cbc35777$var$reactive(data2);
    $a404bd24cbc35777$var$initInterceptors(reactiveData);
    let undo = $a404bd24cbc35777$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $a404bd24cbc35777$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $a404bd24cbc35777$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$a404bd24cbc35777$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $a404bd24cbc35777$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$a404bd24cbc35777$var$isCloning) return false;
    if ($a404bd24cbc35777$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$a404bd24cbc35777$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $a404bd24cbc35777$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $a404bd24cbc35777$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $a404bd24cbc35777$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $a404bd24cbc35777$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$a404bd24cbc35777$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $a404bd24cbc35777$var$parseForExpression(expression);
    let evaluateItems = $a404bd24cbc35777$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $a404bd24cbc35777$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$a404bd24cbc35777$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>$a404bd24cbc35777$var$mutateDom(()=>{
                $a404bd24cbc35777$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $a404bd24cbc35777$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($a404bd24cbc35777$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $a404bd24cbc35777$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $a404bd24cbc35777$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $a404bd24cbc35777$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $a404bd24cbc35777$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!(key in lookup)) continue;
            $a404bd24cbc35777$var$mutateDom(()=>{
                $a404bd24cbc35777$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $a404bd24cbc35777$var$mutateDom(()=>{
                if (!elForSpot) $a404bd24cbc35777$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $a404bd24cbc35777$var$reactive(scope2);
            $a404bd24cbc35777$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $a404bd24cbc35777$var$mutateDom(()=>{
                lastEl.after(clone2);
                $a404bd24cbc35777$var$skipDuringClone(()=>$a404bd24cbc35777$var$initTree(clone2))();
            });
            if (typeof key === "object") $a404bd24cbc35777$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $a404bd24cbc35777$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $a404bd24cbc35777$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $a404bd24cbc35777$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $a404bd24cbc35777$var$handler3() {}
$a404bd24cbc35777$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $a404bd24cbc35777$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$a404bd24cbc35777$var$directive("ref", $a404bd24cbc35777$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$a404bd24cbc35777$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $a404bd24cbc35777$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $a404bd24cbc35777$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $a404bd24cbc35777$var$addScopeToNode(clone2, {}, el);
        $a404bd24cbc35777$var$mutateDom(()=>{
            el.after(clone2);
            $a404bd24cbc35777$var$skipDuringClone(()=>$a404bd24cbc35777$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $a404bd24cbc35777$var$mutateDom(()=>{
                $a404bd24cbc35777$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$a404bd24cbc35777$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$a404bd24cbc35777$var$setIdRoot(el, name));
});
$a404bd24cbc35777$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$a404bd24cbc35777$var$mapAttributes($a404bd24cbc35777$var$startingWith("@", $a404bd24cbc35777$var$into($a404bd24cbc35777$var$prefix("on:"))));
$a404bd24cbc35777$var$directive("on", $a404bd24cbc35777$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $a404bd24cbc35777$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $a404bd24cbc35777$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$a404bd24cbc35777$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$a404bd24cbc35777$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$a404bd24cbc35777$var$warnMissingPluginDirective("Focus", "trap", "focus");
$a404bd24cbc35777$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $a404bd24cbc35777$var$warnMissingPluginDirective(name, directiveName, slug) {
    $a404bd24cbc35777$var$directive(directiveName, (el)=>$a404bd24cbc35777$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$a404bd24cbc35777$var$alpine_default.setEvaluator($a404bd24cbc35777$var$normalEvaluator);
$a404bd24cbc35777$var$alpine_default.setReactivityEngine({
    reactive: $a404bd24cbc35777$var$reactive2,
    effect: $a404bd24cbc35777$var$effect2,
    release: $a404bd24cbc35777$var$stop,
    raw: $a404bd24cbc35777$var$toRaw
});
var $a404bd24cbc35777$export$b7ee041e4ad2afec = $a404bd24cbc35777$var$alpine_default;
// packages/alpinejs/builds/module.js
var $a404bd24cbc35777$export$2e2bcd8739ae039 = $a404bd24cbc35777$export$b7ee041e4ad2afec;


Object.assign(window, {
    Alpine: $a404bd24cbc35777$export$2e2bcd8739ae039
});
// 日本語環境か確認する
const $a2f941f220001584$var$isJapanese = navigator.language.startsWith('ja');
document.addEventListener('alpine:init', ()=>{
    (0, $a404bd24cbc35777$export$2e2bcd8739ae039).data('app', ()=>({
            isJapanese: $a2f941f220001584$var$isJapanese
        }));
});
(0, $a404bd24cbc35777$export$2e2bcd8739ae039).start();


//# sourceMappingURL=index.824e0585.js.map
